module.exports = __webpack_public_path__ + "static/media/indus3.453eab38.jpeg";